import type { ParsedUrlQuery } from 'querystring'

export function sanitizeQueryValue(key: string): string {
  return key.toLowerCase().replace(/[^a-z0-9|-]/g, '')
}

export function parseQueryValue(queryKey: string, query: ParsedUrlQuery): string | null {
  const queryValue = query[queryKey]
  return queryValue == null || queryValue === '' ? null : `${queryValue}`
}
